import React, { useEffect, useState } from 'react';
import Button from '@material-ui/core/Button';
import ShowChartIcon from '@mui/icons-material/ShowChart';
import Stack from '@mui/material/Stack';
import EmptyValuations from './EmptyValuations';

type Valuation = {
  id: number;
  ticker: string;
  growth_rate: string;
  future_pe: number;
};

function Valuations() {
  const [valuations, setValuations] = useState<Valuation[] | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let isMounted = true;

    fetch('/profile/valuations')
      .then((resp) => {
        if (!resp.ok) {
          throw new Error('Unable to load valuations');
        }
        return resp.json();
      })
      .then((data) => {
        if (isMounted) {
          setValuations(data || []);
        }
      })
      .catch(() => {
        if (isMounted) {
          setError('Unable to load valuations');
        }
      });

    return () => {
      isMounted = false;
    };
  }, []);

  if (error) {
    return (
      <div className="py-4 border-bottom">
        <p className="clearfix">
          <p><strong>Preset Valuations</strong></p>
          <div>Unable to load valuations right now.</div>
        </p>
      </div>
    );
  }

  if (!valuations) {
    return (
      <div className="py-4 border-bottom">
        <p className="clearfix">
          <p><strong>Preset Valuations</strong></p>
          <div>Loading valuations...</div>
        </p>
      </div>
    );
  }

  if (valuations.length === 0) {
    return <EmptyValuations />;
  }

  return (
    <div className="py-4 border-bottom">
      <p className="clearfix">
       <p><strong>Preset Valuations</strong></p>
      </p>
      <div className="table-responsive">
        <table className="table table-striped table-sm">
          <thead>
            <tr>
              <th></th>
              <th><strong>Growth Rate</strong></th>
              <th><strong>Future PE</strong></th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            { valuations.map((item =>
              <tr key={item.id}>
                <td>{item.ticker}</td>
                <td>{item.growth_rate}</td>
                <td>{item.future_pe}</td>
                <td>
                  <form>
                    <Stack direction="row" spacing={2}>
                      <Button href={"/ticker/" + item.ticker} size="small" variant="outlined" startIcon={<ShowChartIcon />}>View</Button>
                    </Stack>
                  </form>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

    </div>
  );
}

export default Valuations;
